import { EnvironmentConfig, EnvironmentStatus } from "src/classes/EnvironmentHelper";

export const ENVIRONMENT: EnvironmentConfig = {
  DEBUG: false,
  STATUS: EnvironmentStatus.PRODUCTION,
};
